var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page-structure',{attrs:{"title":"portfolio","loading":_vm.loading}},[(_vm.pictures.length > 0)?_c('pictures-grid',{attrs:{"pictures":_vm.pictures}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }